import { render, staticRenderFns } from "./BabyWearing.vue?vue&type=template&id=c85e96b6&scoped=true&"
import script from "./BabyWearing.vue?vue&type=script&lang=js&"
export * from "./BabyWearing.vue?vue&type=script&lang=js&"
import style0 from "./BabyWearing.vue?vue&type=style&index=0&id=c85e96b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85e96b6",
  null
  
)

export default component.exports